import { gql } from '@apollo/client';

export const USER_LIST_QUERY = gql`
  query userPagedList($pager: PagerInputNew, $filters: UserFilterInput) {
    userPagedList(pager: $pager, filters: $filters) {
      total
      values {
        id
        name
        remark
        inactive
        lastLoginDate
      }
    }
  }
`;
